<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.CraftDesignation"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-craft-designation">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
